module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/modules/_iterators.js
// module id = 58
// module chunks = 19